<template lang="pug">
  crud-form( v-bind="formPropsExtra"  @submitForm="submitForm" @reset="reset")
</template>

<script>
import { CrudForm } from '@/components/reusable_components'
import { EmployeeExtraInformationFields } from './fields'
import CivilStatusService from '@/services/api/general/gCivilStatus'
import ProviredEmployeeService from '@/services/api/hrPreviredEmployeeType'
import ProviderNationalityService from '@/services/api/hrPreviredNationality'
import EmployeeService from '@/services/api/employee'
/* vuex */
import { mapState, mapActions } from 'vuex'
export default {
    name: 'employee-extra-info',
    // props: {
    //   employee:{
    //     type: Object,
    //     required: true,
    //   },
    // },
    data: function() {
        return {
            extraFields: EmployeeExtraInformationFields,
            //employee:{}
        }
    },
    computed: {
        /*
         */
        ...mapState('EmployeeModule', {
            employee: 'employee',
        }),
        formPropsExtra() {
            return {
                editable: this.$can('EDIT_EMPLOYEE'),
                readOnly: !this.$can('EDIT_EMPLOYEE'),
                class: 'elevation-0',
                fields: this.extraFields,
                submitText: 'Guardar',
                //noButtons: true,
                ref: 'form',
            }
        },
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        // -- Data handling and transformations
        // -- Validations and Error handling
        setExtraInformationOptionData: function(index, value) {
            this.extraFields[index].options.data = value
        },
        setExtraInformationValue: function(index, value) {
            this.extraFields[index].value = value
        },
        initEmployeeInfo() {
            //this.employee = await EmployeeService.fetchById( this.$route.params.id )

            this.$nextTick(() => {
                this.$refs.form.vmodels.gender = this.employee.gender
                this.$refs.form.vmodels.g_civil_status_id = this.employee.g_civil_status_id
                this.$refs.form.vmodels.hr_previred_employee_type_id = this.employee.hr_previred_employee_type_id
                this.$refs.form.vmodels.hr_previred_nationality_id = this.employee.hr_previred_nationality_id
                this.$refs.form.vmodels.has_subsidy_young_worker = this.employee.has_subsidy_young_worker
                this.$refs.form.vmodels.family_assignment_average_incoming = this.employee.family_assignment_average_incoming
            })
        },

        /*
         */
        async submitForm(event) {
            let employeeSub = { ...this.employee, ...event }
            let resp = await EmployeeService.update(
                this.$route.params.id,
                employeeSub
            )
            this.resetSnackbarState()

            if (resp.status === 'success') {
                let payload = this.fillSnack(
                    'success',
                    'Información extra',
                    'Datos guardados exitosamente'
                )
                this.initSnackbar(payload)
                this.$refs.form.editSwitch = false
            } else {
                let payload = this.fillSnack('error', 'Error', response)
                this.initSnackbar(payload)
            }
        },
        reset() {
            console.log('reset')
            //this.setExtraInformationValue(0, 'F')
            this.initEmployeeInfo()
        },
        // -- Other functions
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    // watch: {},
    components: {
        'crud-form': CrudForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    beforeMount: async function() {
        this.setExtraInformationOptionData(
            2,
            await CivilStatusService.fetchAll()
        )
        this.setExtraInformationOptionData(
            3,
            await ProviredEmployeeService.fetchAll()
        )
        this.setExtraInformationOptionData(
            4,
            await ProviderNationalityService.fetchAll()
        )
        this.initEmployeeInfo()
        //this.initEmployee2()
        //console.log(this.employee.gender, 'employee')
        //this.setExtraInformationValue(0, 2)

        //console.log(this.employee.gender, 'employee')
    },
    mounted: function() {
        //this.initEmployeeInfo()
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>